module.exports = __webpack_public_path__ + "static/media/eating.ca53d107.svg";